export default {
  switchAccount: "เปลี่ยนบัญชี",
  login: "ล็อกอิน",
  loginFirst: "โปรดล็อกอินก่อน",
  start: "เริ่มตอบคำถาม",
  hasHistory: "ก่อนหน้านี้ ท่านได้ตอบคำถามบางส่วนแล้ว",
  loadHistory: "ต้องการทำต่อจากครั้งที่แล้วไหม?",
  cancel: "ยกเลิก",
  confirm: "ยืนยัน",
  contact: "หากป้อนช่องทางติดต่อ จะมีโอกาสได้รับรางวัลนะ!",
  completed: "ยินดีด้วย ท่านตอบแบบสอบถามเสร็จสิ้นแล้ว",
  leaveMessage: "ป้อนช่องทางติดต่อของท่าน จะได้สิทธิ์จับรางวัล",
  enterEmail: "โปรดป้อนอีเมลของท่าน :",
  enterPhone: "โปรดป้อนเบอร์มือถือของท่าน :",
  submit: "ส่ง",
  leave: "ออก",
  submitted: "ส่งแล้ว",
  thanks: "ขอบคุณสำหรับการสนับสนุน",
  opinion: "โปรดป้อนความคิดเห็นของท่าน",
  prev: "ข้อที่แล้ว",
  next: "ข้อถัดไป",
  unlikely: "เป็นไปไม่ได้",
  likely: "เป็นไปได้มาก",
  claimYourRewards: "นี่คือรางวัลที่ท่านได้รับ",
  rewardSent: "ส่งรางวัลให้เรียบร้อยแล้ว",
  checkInGame: "สามารถเช็คดูได้ในเกม",
  copy: "คัดลอก",
  copied: "คัดลอกสำเร็จ",
  selectTips: "โปรดเลือก",
  multipleTips: "ข้อนี้สามารถเลือกได้หลายข้อ",
  leastChoose: "เลือกได้สูงสุด xxx ข้อ",
  maxChoose: "อย่างน้อยต้องเลือก xxx ข้อ",
  mustAnswer: "โปรดตอบข้อนี้",
  mustWrite: "โปรดป้อนรายละเอียด",
  checkEmail: "โปรดป้อนอีเมลที่ถูกต้อง",
  checkPhone: "โปรดป้อนเบอร์มือถือที่ถูกต้อง",
  isAnswer: "ท่านตอบคำถามแล้ว",
  unStart: "กิจกรรมยังไม่เริ่ม",
  end: "กิจกรรมสิ้นสุดแล้ว",
  server: "โปรดเลือกเซิร์ฟ",
  role: "โปรดเลือกตัวละคร",
  common: "ระบบกำลังยุ่ง โปรดลองใหม่ภายหลัง",
  title: "แบบสอบถาม",
  titleAward: "แบบสอบถาม",
  leastWord: "จำนวนที่ท่านป้อนต่ำกว่า xxx",
  maxWord: "จำนวนที่่ท่านป้อนมากกว่า xxx",
  singleChoose: "เลือกได้เพียง 1 ข้อ",
  multiChoose: "เลือกได้หลายข้อ",
  matrix: "คำถามวิเคราะห์",
  score: "ให้คะแนน",
  textLimit: "(xx-yyy ตัวอักษร)",
  coverGiftTitle: "กรอกแบบสอบถามเพื่อรับของขวัญ",
  "-20001": "ยังไม่ได้ล็อกอิน",
  "-20002": "ขาดพารามิเตอร์ที่จำเป็น",
  "-20003": "ไม่พบแบบสอบถาม",
  "-20004": "แบบสอบถามกำลังตั้งค่า",
  "-20005": "แบบสอบถามถูกหยุด",
  "-20006": "กิจกรรมแบบสอบถามยังไม่เริ่ม",
  "-20007": "กิจกรรมแบบสอบถามสิ้นสุดแล้ว",
  "-20008": "ตอบแล้ว",
  "-20010": "การแจกรางวัลล้มเหลว",
  "-20011": "แบบสอบถามนี้ได้แจกรางวัลแล้ว",
  "-20012": "ยังไม่ได้ตอบ",
  "-20016": "รหัสเกมไม่ถูกต้อง",
};
